import { useEffect } from "react";
import { useForm } from "../../useForm";
import SetupSlideOverFormActions from "../SetupSlideOverFormActions";
import { useSlideOverSubmit } from "../useSlideOverSubmit";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";
import SelectMenu from "../../../controls/SelectMenu";

const initialFValues = {
  name: "",
  taxes: [],
};

export default function ManufacturersForm(props) {
  const { index, manufacturer, setOpen, actionCall, isEdit, taxRatesOptions } =
    props;

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, false);
  const { submitting, runSubmit } = useSlideOverSubmit();

  const handleSubmit = (e) => {
    e.preventDefault();
    runSubmit(async () => {
      if (isEdit) {
        await actionCall(manufacturer, values, index);
      } else {
        await actionCall(values);
      }
    });
  };

  useEffect(() => {
    if (isEdit && manufacturer) {
      setValues({
        name: manufacturer.name,
        taxes: manufacturer.taxes || [],
      });
    }
  }, [manufacturer, setValues, isEdit]);

  return (
    <div className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {isEdit ? "Edit " + manufacturer.name : "Add new supplier"}
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6">
          <div>
            <div className="mt-2">
              <Input
                label="Name"
                name="name"
                onChange={handleInputChange}
                value={values.name}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
            </div>
            <div className="mt-3">
              <SelectMenu
                isMulti={true}
                handleInputChange={handleInputChange}
                name="taxes"
                options={taxRatesOptions}
                defaultValue={isEdit ? manufacturer?.taxes : null}
                title={"Tax rates"}
                value={values.taxes}
              />
            </div>
          </div>
        </div>
      </div>
      <SetupSlideOverFormActions
        setOpen={setOpen}
        isEdit={isEdit}
        submitting={submitting}
        onSubmit={handleSubmit}
      />
    </div>
  );
}
